import { layoutRoute } from '@app/router/layout';
import { createRoute } from '@tanstack/react-router';
import HomePage from '@modules/core/presentation/v1/pages/Home';
import AccountPage from '@modules/core/presentation/v1/pages/Account';

export const HomeRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/',
  beforeLoad: () => ({ breadcrumb: { key: 'home' } }),
  component: () => (
    <HomePage />
  ),
});

export const AccountRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/account',
  beforeLoad: () => ({ breadcrumb: { key: 'account' } }),
  component: () => (
    <AccountPage />
  ),
});
